/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequest,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenPathParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen.ts";

function getPostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenUrl(
  financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenPathParams["financialPersonId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/financial-people/${financialPersonId}/parcels/cancel-open` as const,
  };
  return res;
}

/**
 * @description Cancela as parcelas informadas que pertencem ao plano e estão pendentes ou aguardando integração. Migrado do legado IndividualPayment/CancelOpenParcels. **(Requer Authorization para autenticação)**
 * @summary Cancela parcelas abertas do plano (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/parcels/cancel-open}
 */
export async function postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen(
  financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenPathParams["financialPersonId"],
  data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen500
    >,
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequest
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenUrl(
      financialPersonId,
    ).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
